var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 280,
    viewBox: "0 0 500 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.8009 153.197C31.0103 142.48 38.3197 133.324 48.2148 130.225C63.0457 125.485 81.0593 122.399 85.1528 102.691C86.6391 95.5354 86.4077 88.0864 87.1139 80.7818C87.8211 73.4773 89.6793 65.8851 94.4136 60.8144C103.044 51.5696 115.337 54.7519 125.344 58.5552C128.944 59.9225 132.51 61.2043 135.95 61.8482C140.967 62.9748 146.081 62.4657 150.812 60.6134C159.512 57.4744 164.984 49.0313 170.818 41.7051C177.422 33.4124 185.777 27.9685 195.837 27.1128C205.443 26.2956 213.903 29.4622 221.198 36.5922C227.24 42.4982 232.099 49.804 238.124 55.7352C244.136 61.6545 251.379 66.1679 259.235 67.8397C270.038 70.1397 281.042 66.2365 288.63 57.3324C296.753 47.8 301.275 35.1383 310.136 25.9056C326.495 8.86163 349.571 6.59047 370.491 12.1209C391.862 17.7706 415.783 31.1015 428.734 51.6274C443.605 75.196 438.083 106.062 423.235 127.847C421.595 130.63 420.042 133.447 418.943 136.56C417.509 140.639 417.605 145.254 419.708 149.226C421.811 153.198 425.252 155.774 429.17 156.096C439.014 156.954 450.579 153.412 458.129 163.18C470.553 179.068 470.075 201.717 463.167 219.833C462.2 222.518 461.125 225.169 459.981 227.786C456.546 235.64 452.48 243.207 448.746 250.582C446.733 254.345 444.586 257.97 442.294 261.45C440.002 264.929 437.565 268.264 434.993 271.434H63.3019C56.8894 271.434 52.3148 259.956 53.4014 252.194C54.3444 245.455 58.9062 240.251 60.3292 233.64C61.1983 229.601 60.8018 225.569 59.5673 221.788C55.9507 210.711 47.23 205.033 39.777 197.698C32.0798 190.124 26.7368 179.292 26.067 167.724C25.7841 162.834 26.4035 157.868 27.8019 153.199L27.8009 153.197Z",
    fill: "url(#paint0_linear_4156_16752)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M464.93 173.818C463.948 173.778 463.001 173.903 462.116 174.17C462.12 174.063 462.123 173.956 462.123 173.849C462.123 168.693 457.888 164.515 452.663 164.515C451.205 164.515 449.822 164.842 448.589 165.423C446.612 162.39 443.145 160.391 439.208 160.435C433.349 160.501 428.526 165.169 428.349 170.945C428.329 171.62 428.371 172.28 428.47 172.922C428.276 172.91 428.082 172.902 427.885 172.902C422.843 172.902 418.782 177.045 419.009 182.069C419.222 186.772 423.242 190.434 428.013 190.434H464.575C469.265 190.434 473.06 186.653 472.999 182.012C472.942 177.626 469.374 173.997 464.932 173.816L464.93 173.818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.461 272.434C252.357 272.434 242.118 262.161 242.118 248.009C242.118 233.857 252.355 223.965 266.461 223.965C280.567 223.965 290.802 234.076 290.802 248.009C290.802 261.941 280.566 272.434 266.461 272.434ZM245.231 214.084C243.651 214.084 242.307 212.936 242.065 211.38C238.517 188.412 253.199 175.604 264.998 165.313C271.951 159.248 277.956 154.011 277.956 148.568C277.956 138.954 267.908 138.207 264.828 138.207C255.476 138.207 249.397 142.62 241.828 148.856C241.235 149.344 240.51 149.587 239.787 149.587C239.01 149.587 238.236 149.308 237.625 148.751L212.041 125.447C210.756 124.277 210.646 122.299 211.792 120.995C226.846 103.868 246.841 94.4344 268.094 94.4344C285.347 94.4344 300.054 98.3353 310.624 105.716C322.646 114.11 329 126.865 329 142.606C329 162.068 316.949 172.546 306.316 181.79C296.524 190.304 288.066 197.658 289.248 210.605C289.33 211.497 289.03 212.382 288.423 213.043C287.817 213.704 286.958 214.081 286.06 214.081H245.232L245.231 214.084Z",
    fill: "#078FCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.972 193.442C268.967 193.771 271.077 199.771 267.64 207.736C267.463 208.147 267.266 208.568 267.056 208.998C264.822 209.772 262.316 210.42 260.055 210.915C256.903 211.604 254.226 211.998 253.427 212.025C251.827 212.079 251.494 213.06 252.829 213.315C253.523 213.448 256.504 213.552 260.379 213.156C262.703 212.918 265.349 212.502 268.016 211.802C268.375 211.709 268.71 211.535 269 211.296C269.231 211.106 269.43 210.877 269.585 210.618C270.198 209.606 270.774 208.559 271.292 207.486C275.275 199.25 274.3 193.188 271.973 193.442H271.972Z",
    fill: "url(#paint1_linear_4156_16752)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.271 212.937C261.54 213.039 260.791 213.127 260.044 213.2C258.906 213.312 257.766 213.391 256.651 213.434C256.476 213.441 256.322 213.314 256.302 213.144C256.222 212.497 256.126 211.93 256.008 211.411C255.988 211.323 256.006 211.231 256.056 211.157C256.108 211.082 256.189 211.031 256.279 211.016C257.348 210.836 258.501 210.615 259.614 210.379C262.157 209.841 264.522 209.218 266.46 208.576C266.649 208.199 266.823 207.833 266.977 207.49C268.616 203.816 268.985 200.544 269.254 198.155C269.545 195.567 269.755 193.696 271.512 193.454C271.538 193.45 271.566 193.447 271.594 193.444C272.215 193.378 272.765 193.649 273.185 194.227C274.571 196.145 274.353 201.327 271.253 207.524C270.751 208.527 270.171 209.557 269.527 210.586C269.35 210.869 269.127 211.119 268.867 211.327C268.541 211.587 268.155 211.78 267.751 211.881C266.025 212.318 264.182 212.674 262.273 212.938L262.271 212.937Z",
    fill: "url(#paint2_linear_4156_16752)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M265.288 217.607C264.508 217.467 264.149 217.91 263.94 217.985C263.732 218.059 263.083 218.691 263.003 218.317C262.924 217.943 264.387 215.047 265.367 214.567C266.347 214.085 269 215.07 269 215.07L268.861 217.138C267.89 218.136 265.973 217.734 265.288 217.609V217.607Z",
    fill: "#A15058"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.582 191.691C281.735 192.129 283.79 193.879 283.93 196.155C283.97 196.447 283.993 196.762 283.999 197.1C284.02 198.452 283.751 200.186 283.087 202.453C281.127 209.143 280.163 213.434 280.163 213.434H270.521C270.521 213.434 270.553 212.5 270.5 212.104C270.448 211.709 270.368 211.144 270.282 210.47C270.072 208.13 270.116 207.181 269.738 204.831C269.674 204.437 269.612 204.044 269.551 203.646C269.524 202.741 269.38 201.764 269.254 200.774C269.212 200.442 269.171 200.111 269.136 199.778C268.781 198.124 269.143 196.586 269.963 195.289C270.168 194.964 270.402 194.653 270.66 194.36C272.645 192.454 275.528 191.127 278.449 191.496C279.188 191.541 279.582 191.691 279.582 191.691Z",
    fill: "url(#paint3_linear_4156_16752)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.218 195.436C270.218 195.436 267.665 198.62 267.085 200.049C266.522 201.441 268.939 203.434 268.939 203.434C268.939 203.434 270.702 202.965 270.954 200.064C271.223 196.994 270.217 195.434 270.217 195.434L270.218 195.436Z",
    fill: "url(#paint4_linear_4156_16752)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.837 258.434C252.837 258.434 253.312 259.006 253.627 259.889C253.78 260.317 253.899 260.74 253.981 261.063C254.064 261.388 253.864 261.762 253.521 261.931C251.73 262.816 247.232 264.976 244.786 265.427C244.197 265.535 243.322 264.479 244.864 263.418C246.405 262.358 249.085 259.075 249.085 259.075L252.837 258.436V258.434Z",
    fill: "url(#paint5_linear_4156_16752)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.999 228.452L274.132 218.434C269.391 218.585 262.444 218.556 260.44 218.601C254.853 218.724 251.176 219.124 249.377 219.37C248.557 219.483 247.777 219.765 247.081 220.201C246.02 220.868 245.194 221.868 244.718 223.075C244.522 223.57 244.334 224.077 244.213 224.499C243.693 226.323 231 255.402 231 255.402L234.564 255.434C234.564 255.434 244.832 241.691 247.95 235.791C249.601 232.669 250.421 229.23 250.826 226.647C254.248 227.276 257.984 227.599 262.626 228.084C266.276 228.466 273.075 228.681 277 228.452C276.993 228.444 276.985 228.437 277 228.452H276.999Z",
    fill: "url(#paint6_linear_4156_16752)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.568 255.619C234.568 255.619 234.87 256.363 234.952 257.412C234.991 257.921 235.001 258.417 235 258.793C235 259.17 234.731 259.535 234.377 259.642C232.53 260.194 227.907 261.513 225.563 261.431C224.999 261.41 224.445 260.036 226.105 259.231C227.763 258.425 230.985 255.434 230.985 255.434L234.568 255.617V255.619Z",
    fill: "url(#paint7_linear_4156_16752)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.115 212.434H270.899C270.866 212.434 269.966 216.496 270.001 218.567C270.014 219.329 270.65 223.879 271.003 228.139C271.003 228.139 277.847 228.433 277.99 228.434C279.156 228.446 280.026 228.007 280.905 227.385C281.771 226.773 282.516 225.728 282.932 223.408C283.521 220.115 280.116 212.434 280.116 212.434H280.115Z",
    fill: "url(#paint8_linear_4156_16752)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.581 218.434C263.708 219.041 252.457 220.016 249.452 220.982C249.139 221.082 248.796 221.228 248.45 221.405C247.044 222.125 246.118 223.512 246.001 225.065C245.935 225.941 248.838 259.434 248.838 259.434L252.281 259.246C252.281 259.246 254.15 241.335 254.473 235.218C254.609 232.658 254.187 230.106 253.643 227.991C257.177 228.202 264.958 228.458 268.949 228.565C271.1 228.622 273.985 228.557 277 228.434C276.992 228.429 276.985 228.423 277 228.434L268.581 218.436V218.434Z",
    fill: "url(#paint9_linear_4156_16752)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M282.982 224.434C282.971 224.434 282.96 224.434 282.947 224.432C282.943 224.432 282.939 224.432 282.935 224.429C282.896 224.42 280.338 220.439 276.489 219.504C274.228 218.955 272.427 218.514 271.135 218.196C270.405 218.016 269.797 217.864 269.371 217.755C268.864 217.625 268.614 217.527 268.621 217.459C268.655 217.137 268.717 216.634 268.797 215.998C269.077 213.757 269.546 210.005 269.426 208.315C269.345 207.174 269.282 206.274 269.026 204.747C268.971 204.422 268.917 204.096 268.863 203.767C268.575 203.515 266.546 201.668 267.093 200.27C267.244 199.885 267.46 199.532 267.669 199.191C267.902 198.81 268.144 198.417 268.288 197.984C268.37 197.734 268.443 197.479 268.513 197.23C268.697 196.577 268.886 195.901 269.285 195.297C269.497 194.974 269.744 194.66 270.018 194.363C271.788 192.735 273.976 191.714 276.186 191.484C276.482 191.453 276.774 191.437 277.055 191.437H277.123C277.177 191.437 277.236 191.434 277.294 191.434C280.14 191.434 282.885 192.986 283.813 195.666C283.912 196.02 283.968 196.774 283.99 197.136C284.013 197.504 283.996 197.873 283.94 198.233C283.924 198.504 283.896 198.804 283.857 199.115C283.723 200.207 283.484 201.35 283.127 202.61C282.907 203.387 282.614 204.165 282.33 204.916C281.9 206.055 281.547 207.642 281.356 208.824C280.962 211.268 280.86 213.005 281.762 214.962C281.856 215.165 281.957 215.365 282.045 215.57C284 220.187 283.896 222.417 283.221 224.208C283.197 224.271 283.191 224.336 283.137 224.38C283.094 224.413 283.039 224.432 282.984 224.432L282.982 224.434Z",
    fill: "url(#paint10_linear_4156_16752)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279 181.338C279 181.338 280.71 178.302 281.575 178.439C282.44 178.576 282.424 179.404 282.424 179.404C282.424 179.404 283.539 178.768 284.316 179.909C285.092 181.05 284.553 181.777 284.553 181.777C284.553 181.777 285.114 181.908 284.979 182.444C284.845 182.978 284.324 183.11 284.324 183.11C284.324 183.11 284.839 183.502 284.376 184.236C283.911 184.969 283.193 184.429 283.193 184.429C283.193 184.429 283.557 184.948 283.035 185.339C282.516 185.729 282.088 184.797 282.085 184.791C282.133 184.896 281.657 185.153 281.598 185.17C281.12 185.315 280.874 184.988 280.698 184.59C280.204 183.473 279.575 182.414 279.001 181.337L279 181.338Z",
    fill: "url(#paint11_linear_4156_16752)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.188 185.436C278.188 185.436 277.888 186.87 278.058 188.364C278.227 189.85 278.993 190.87 278.993 190.87C279.124 190.937 277.289 192.061 276.467 192.269C274.703 192.713 273.94 192.179 274.004 191.674C274.004 191.674 274.648 190.213 274.863 188.581C275.13 186.538 274.648 185.615 274.648 185.615L278.186 185.434L278.188 185.436Z",
    fill: "#A15058"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.419 179.435C281.343 179.392 281.704 183.718 280.255 185.53C278.927 187.191 278.513 186.319 277.797 187.642C277.246 188.66 274.95 189.524 273.825 189.427C272.699 189.33 271.543 187.376 272.183 184.085C272.828 180.764 274.613 179.451 276.419 179.436V179.435Z",
    fill: "#A15058"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M273.371 181.721C274.04 182.193 274.852 182.193 275.596 182.006C275.722 181.999 275.844 182.005 275.958 182.023C276.62 182.126 277.134 182.69 277.328 183.406C277.621 184.488 277.67 185.577 277.817 186.68C277.829 186.773 277.849 186.861 277.876 186.942C277.92 187.072 277.98 187.182 278.064 187.269C278.203 187.369 278.344 187.42 278.485 187.434C279.374 187.355 279.923 186.371 280.396 185.666C280.458 185.543 280.513 185.417 280.562 185.287C280.611 185.158 280.653 185.025 280.688 184.889C280.727 184.767 280.764 184.641 280.797 184.509C280.965 183.851 281.057 183.075 280.962 182.305C280.935 182.102 280.898 181.901 280.842 181.7C280.796 181.554 280.743 181.413 280.687 181.274C280.178 179.677 278.77 178.795 277.317 178.539C277.135 178.506 276.952 178.485 276.771 178.472C275.939 178.343 275.209 178.561 274.474 178.895C274.199 179.065 273.908 179.234 273.664 179.455C273.582 179.528 273.506 179.608 273.437 179.694C273.16 180.11 272.742 180.92 273.213 181.523C273.29 181.625 273.371 181.721 273.371 181.721Z",
    fill: "url(#paint12_linear_4156_16752)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M277.453 184.841C277.453 184.841 279.202 183.6 278.981 185.454C278.762 187.304 277 187.434 277 187.434L277.453 184.841Z",
    fill: "#A15058"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M280.433 192.519C277.594 193.604 281.208 198.799 279.936 207.298C279.87 207.736 279.789 208.189 279.695 208.653C277.723 209.966 275.452 211.228 273.379 212.281C270.491 213.748 267.987 214.811 267.217 215.041C265.675 215.502 265.605 216.526 266.97 216.428C267.681 216.377 270.608 215.712 274.277 214.34C276.477 213.517 278.944 212.44 281.359 211.089C281.684 210.908 281.966 210.656 282.186 210.354C282.361 210.111 282.494 209.842 282.578 209.555C282.91 208.429 283.198 207.28 283.424 206.122C285.158 197.226 282.631 191.679 280.432 192.518L280.433 192.519Z",
    fill: "#A15058"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.055 210.682C281.878 210.876 281.678 211.041 281.46 211.172C280.052 212.02 278.52 212.818 276.906 213.546C276.288 213.825 275.652 214.096 275.014 214.353C274.043 214.743 273.06 215.103 272.091 215.42C271.939 215.47 271.773 215.386 271.714 215.229C271.487 214.628 271.266 214.109 271.035 213.64C270.996 213.562 270.99 213.468 271.016 213.384C271.03 213.338 271.054 213.297 271.086 213.263C271.112 213.234 271.143 213.21 271.178 213.193C272.074 212.754 273.032 212.256 273.95 211.755C276.053 210.607 277.979 209.422 279.524 208.324C279.598 207.917 279.663 207.523 279.714 207.155C280.262 203.224 279.791 199.995 279.447 197.639C279.127 195.45 278.897 193.867 279.69 192.996C279.849 192.821 280.051 192.677 280.287 192.57C280.31 192.559 280.333 192.55 280.357 192.54C280.886 192.321 281.436 192.444 281.944 192.895C283.627 194.389 284.693 199.412 283.476 206.124C283.28 207.208 283.019 208.341 282.704 209.489C282.618 209.804 282.482 210.098 282.304 210.363C282.228 210.474 282.144 210.582 282.053 210.682H282.055Z",
    fill: "url(#paint13_linear_4156_16752)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M252.479 211.449C251.915 211.465 251.245 211.352 251.211 211.575C251.194 211.685 251.782 211.785 252.312 211.897C251.872 211.919 251.486 211.969 251.248 212.031C250.533 212.216 250.131 211.987 249.926 211.971C249.719 211.956 249.049 211.721 249.001 211.898C248.953 212.075 250.583 213.276 251.56 213.414C252.538 213.552 255 212.947 255 212.947L254.818 212.223C254.769 211.721 253.045 211.433 252.48 211.449H252.479Z",
    fill: "url(#paint14_linear_4156_16752)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M251.578 219.434H258.558C258.878 219.434 259.066 219.169 258.978 218.84L254.163 201.028C254.075 200.701 253.742 200.434 253.422 200.434H246.442C246.122 200.434 245.934 200.7 246.022 201.028L250.837 218.84C250.925 219.168 251.258 219.434 251.578 219.434Z",
    fill: "url(#paint15_linear_4156_16752)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.702 219.434H274.302C274.688 219.434 275 219.097 275 218.682C275 218.266 274.688 217.929 274.302 217.929H258.761L254.369 200.984C254.265 200.584 253.88 200.351 253.51 200.462C253.139 200.574 252.923 200.989 253.026 201.389L257.702 219.434Z",
    fill: "url(#paint16_linear_4156_16752)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250.939 206.309C251.071 206.857 250.981 207.358 250.738 207.427C250.495 207.495 250.191 207.108 250.061 206.56C249.929 206.012 250.019 205.511 250.262 205.442C250.505 205.374 250.809 205.761 250.939 206.309Z",
    fill: "url(#paint17_linear_4156_16752)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M176.83 254.436C176.83 254.436 176.146 254.888 175.654 255.714C175.415 256.114 175.211 256.515 175.064 256.822C174.917 257.13 175.03 257.526 175.327 257.742C176.876 258.865 180.78 261.624 183.055 262.41C183.603 262.599 184.674 261.679 183.403 260.418C182.133 259.156 180.036 255.581 180.036 255.581L176.83 254.434V254.436Z",
    fill: "url(#paint18_linear_4156_16752)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.418 271.434C155.966 271.434 156.487 271.118 156.72 270.588L219.882 126.402C220.195 125.69 219.864 124.861 219.146 124.551C218.428 124.242 217.592 124.569 217.28 125.281L154.118 269.467C153.805 270.179 154.136 271.008 154.854 271.318C155.037 271.396 155.229 271.434 155.418 271.434Z",
    fill: "url(#paint19_linear_4156_16752)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.148 137.434H241.852C242.485 137.434 243 136.762 243 135.934C243 135.107 242.485 134.434 241.852 134.434H215.148C214.515 134.434 214 135.107 214 135.934C214 136.762 214.515 137.434 215.148 137.434Z",
    fill: "url(#paint20_linear_4156_16752)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210.069 150.434H234.931C235.521 150.434 236 149.986 236 149.434C236 148.883 235.521 148.434 234.931 148.434H210.069C209.479 148.434 209 148.883 209 149.434C209 149.986 209.479 150.434 210.069 150.434Z",
    fill: "url(#paint21_linear_4156_16752)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.148 164.434H229.852C230.485 164.434 231 163.986 231 163.434C231 162.883 230.485 162.434 229.852 162.434H203.148C202.515 162.434 202 162.883 202 163.434C202 163.986 202.515 164.434 203.148 164.434Z",
    fill: "url(#paint22_linear_4156_16752)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M197.109 179.434H222.891C223.503 179.434 224 178.986 224 178.434C224 177.883 223.503 177.434 222.891 177.434H197.109C196.497 177.434 196 177.883 196 178.434C196 178.986 196.497 179.434 197.109 179.434Z",
    fill: "url(#paint23_linear_4156_16752)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M191.148 192.434H217.852C218.485 192.434 219 191.986 219 191.434C219 190.883 218.485 190.434 217.852 190.434H191.148C190.515 190.434 190 190.883 190 191.434C190 191.986 190.515 192.434 191.148 192.434Z",
    fill: "url(#paint24_linear_4156_16752)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M185.109 207.434H210.891C211.503 207.434 212 206.762 212 205.934C212 205.107 211.503 204.434 210.891 204.434H185.109C184.497 204.434 184 205.107 184 205.934C184 206.762 184.497 207.434 185.109 207.434Z",
    fill: "url(#paint25_linear_4156_16752)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M179.109 220.434H204.891C205.503 220.434 206 219.986 206 219.434C206 218.883 205.503 218.434 204.891 218.434H179.109C178.497 218.434 178 218.883 178 219.434C178 219.986 178.497 220.434 179.109 220.434Z",
    fill: "url(#paint26_linear_4156_16752)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M173.109 234.434H198.891C199.503 234.434 200 233.986 200 233.434C200 232.883 199.503 232.434 198.891 232.434H173.109C172.497 232.434 172 232.883 172 233.434C172 233.986 172.497 234.434 173.109 234.434Z",
    fill: "url(#paint27_linear_4156_16752)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.148 249.434H192.852C193.485 249.434 194 248.762 194 247.934C194 247.107 193.485 246.434 192.852 246.434H166.148C165.515 246.434 165 247.107 165 247.934C165 248.762 165.515 249.434 166.148 249.434Z",
    fill: "url(#paint28_linear_4156_16752)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M161.109 262.434H186.891C187.503 262.434 188 261.986 188 261.434C188 260.882 187.503 260.434 186.891 260.434H161.109C160.497 260.434 160 260.882 160 261.434C160 261.986 160.497 262.434 161.109 262.434Z",
    fill: "url(#paint29_linear_4156_16752)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M183.397 271.434C183.937 271.434 184.451 271.118 184.679 270.588L246.884 126.402C247.192 125.69 246.866 124.861 246.159 124.551C245.452 124.242 244.629 124.569 244.321 125.281L182.116 269.467C181.808 270.179 182.134 271.008 182.841 271.318C183.022 271.396 183.21 271.434 183.397 271.434Z",
    fill: "url(#paint30_linear_4156_16752)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M177.348 194.996C170.754 188.708 170.45 181.478 167.152 182.539C164.599 183.36 166.124 190.13 173.395 196.433C176.887 199.46 181.083 201.798 184.67 203.434L186 201.279C183.004 199.464 179.64 197.18 177.348 194.995V194.996Z",
    fill: "url(#paint31_linear_4156_16752)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M192.785 204.201C191.96 203.954 189.33 202.882 186.332 201.434L185 203.155C188.885 204.567 192.054 205.324 192.841 205.413C194.354 205.584 194.437 204.696 192.785 204.201Z",
    fill: "url(#paint32_linear_4156_16752)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M173.007 180.751C173.869 179.729 174.253 178.464 174.422 177.232C174.45 177.025 174.614 174.45 174.446 174.475C174.446 174.475 176.722 174.139 177.759 175.406C177.824 175.485 177.884 175.564 177.943 175.64C178.001 175.718 178.057 175.794 178.109 175.869C178.506 176.417 178.689 177.044 178.951 177.565C178.986 177.688 179 177.756 179 177.759C178.985 177.68 178.837 177.707 178.686 177.774C177.886 178.717 177.804 179.868 178.143 180.815C178.166 180.929 178.187 181.04 178.207 181.147C178.226 181.225 178.247 181.303 178.27 181.379C178.292 181.456 178.315 181.532 178.339 181.609C178.357 182.154 177.475 182.734 175.607 182.259C174.737 182.038 172.859 180.824 173.008 180.752L173.007 180.751Z",
    fill: "url(#paint33_linear_4156_16752)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.382 176.27C177.253 176.426 177.784 177.763 179.259 178.25C180.491 178.658 181.156 178.425 181.614 177.191C182.058 175.996 182.595 170.547 180.223 169.269C177.851 167.992 175.09 168.141 173.789 169.989C172.489 171.837 172.446 175.567 176.382 176.269V176.27Z",
    fill: "url(#paint34_linear_4156_16752)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M197.782 205.805C197.512 205.821 196.946 205.479 196.049 205.993C195.75 206.164 195.255 206.347 194.687 206.49C195.395 206.583 196.178 206.64 196.176 206.852C196.172 207.285 195.279 207.222 194.548 207.38C193.817 207.539 191.519 207.384 191.366 206.44L191 205.105C191 205.105 194.1 203.395 195.398 203.435C196.697 203.475 199.03 205.39 199 205.738C198.969 206.087 198.053 205.793 197.782 205.809V205.805Z",
    fill: "url(#paint35_linear_4156_16752)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M166.855 272.434C169.416 272.431 170.329 272.188 169.897 269.981C169.65 268.716 168.443 266.434 168.443 266.434H164.771C164.771 266.434 164.239 268.75 164.04 270.25C163.84 271.75 164.332 272.436 166.853 272.433L166.855 272.434Z",
    fill: "url(#paint36_linear_4156_16752)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.632 202.437C168.632 202.437 165.858 206.933 165.232 211.093C164.894 213.089 164.816 215.863 164.998 219.825C164.998 219.825 164.998 219.826 164.998 219.827C165.006 220.015 165.016 220.206 165.026 220.399C165.049 220.863 165.075 221.317 165.102 221.761C165.333 226.681 165.567 236.315 164.669 244.715C164.669 244.718 164.669 244.72 164.669 244.722C164.603 245.203 164.554 245.706 164.518 246.229C164.517 246.252 164.515 246.276 164.514 246.299C163.68 255.66 164.112 266.434 164.112 266.434H169.607L176.473 223.757C176.612 222.775 181 202.434 181 202.434H168.633L168.632 202.437Z",
    fill: "#078FCA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M179 216.434C179.302 217.083 179.636 217.751 180 218.434L179 216.434Z",
    fill: "url(#paint37_linear_4156_16752)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.977 185.55C183.457 181.937 180.989 180.434 175.369 180.434C169.748 180.434 167.088 181.937 166.102 185.55C165.621 187.314 166.965 191.144 167.564 194.772C168.217 198.734 168.153 202.434 168.153 202.434H180.416C180.416 202.434 180.735 199.129 181.654 195.166C182.462 191.68 184.23 187.318 183.975 185.55H183.977Z",
    fill: "url(#paint38_linear_4156_16752)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M181 201.434H169.107L169 202.434H180.891L181 201.434Z",
    fill: "#0476A7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M207.173 176.392C206.997 176.597 206.365 176.825 206.112 177.747C206.028 178.054 205.818 178.508 205.527 178.995C206.08 178.53 206.661 177.993 206.811 178.106C207.117 178.336 206.458 178.949 206.066 179.563C205.674 180.176 203.982 181.759 203.203 181.375L202 180.939C202 180.939 202.917 177.793 203.839 176.873C204.762 175.953 207.734 175.266 207.961 175.471C208.188 175.675 207.349 176.186 207.173 176.391V176.392Z",
    fill: "url(#paint39_linear_4156_16752)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.739 172.975C170.741 172.957 170.744 172.941 170.747 172.924C170.817 172.32 170.956 171.719 171.163 171.153C171.578 170.042 172.219 168.931 173.232 168.276C173.497 168.08 173.783 167.914 174.089 167.781C174.7 167.516 175.39 167.39 176.154 167.449C176.591 167.441 176.981 167.472 177.328 167.53C177.617 167.579 177.886 167.652 178.137 167.738C179.127 168.32 180.005 168.32 180.98 168.535C182.592 169.072 182.133 171.006 180.719 171.812C180.423 172.121 180.196 172.482 179.997 172.837C179.355 173.979 178.869 175.212 178.647 176.478C178.416 177.795 178.594 179.087 178.856 180.357C179.069 181.392 179.309 182.435 179.288 183.506C179.251 185.357 178.273 186.863 176.622 187.845C171.318 190.997 164.711 189.039 165.01 185.648C165.308 182.256 170.221 176.783 170.74 172.977L170.739 172.975Z",
    fill: "url(#paint40_linear_4156_16752)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.148 185.927C196.573 187.837 194.771 189.892 192.977 191.705C192.822 191.607 192.672 191.51 192.524 191.41C185.112 186.461 183.922 179.981 180.877 181.724C178.519 183.074 180.826 188.842 188.9 193.665C189.876 194.248 190.888 194.777 191.915 195.258C192.344 195.459 192.842 195.49 193.326 195.344C193.74 195.218 194.122 194.971 194.421 194.633C196.573 192.204 198.459 189.66 200 187.363L198.149 185.925L198.148 185.927Z",
    fill: "url(#paint41_linear_4156_16752)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M202.461 180.616C202.014 181.438 200.258 184.039 198 186.992L199.721 188.434C202.115 184.583 203.612 181.418 203.87 180.628C204.363 179.106 203.357 178.972 202.461 180.616Z",
    fill: "url(#paint42_linear_4156_16752)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 231.101C198.085 229.982 197.859 228.856 197.319 227.865C196.837 226.98 196.168 225.79 195.207 224.053C194.551 222.847 193.858 221.577 193.194 220.361C192.278 218.5 191.132 216.405 189.756 214.069C187.983 211.059 186.547 208.894 185.314 207.373C185.226 207.23 185.129 207.086 185.018 206.942C181.39 202.217 180.783 202.436 180.783 202.436L171.815 202.505C171.815 202.505 169.981 210.307 171.815 213.132L171.88 213.11L171.796 213.21C174.787 217.046 178.086 220.634 181.664 223.942C184.463 226.53 187.696 229.522 189.635 231.325C187.072 235.483 182.205 242.826 179.84 247.354C176.826 253.121 176.197 254.26 176.197 254.26L181.711 256.434C181.711 256.434 193.922 238.492 197.105 233.564C197.584 232.822 197.879 231.978 197.969 231.101H197.971Z",
    fill: "#078FCA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M136.682 245.434H80.3184C73.9055 245.434 74.0001 247.898 74.0001 250.934C74.0001 253.973 73.9055 256.434 80.3184 256.434H136.682C143.094 256.434 143 253.971 143 250.934C143 247.896 143.094 245.434 136.682 245.434Z",
    fill: "url(#paint43_linear_4156_16752)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91 245.434H87V256.434H91V245.434Z",
    fill: "url(#paint44_linear_4156_16752)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131 245.434H128V256.434H131V245.434Z",
    fill: "url(#paint45_linear_4156_16752)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72 225.434H125.886C131.467 225.434 136 229.916 136 235.434C136 240.953 131.467 245.434 125.886 245.434H72V225.434Z",
    fill: "url(#paint46_linear_4156_16752)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M70 225.434H85.0558C90.5437 225.434 95 229.916 95 235.434C95 240.953 90.5437 245.434 85.0558 245.434H70V225.434Z",
    fill: "url(#paint47_linear_4156_16752)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M70 226.434H84.7818C89.3175 226.434 93 230.243 93 234.934C93 239.626 89.3175 243.434 84.7818 243.434H70V226.434Z",
    fill: "url(#paint48_linear_4156_16752)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M83 238.434H70V239.434H83V238.434Z",
    fill: "url(#paint49_linear_4156_16752)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M79 256.434H128.523C132.649 256.434 136 259.944 136 264.268V264.601C136 268.924 132.65 272.434 128.523 272.434H79V256.436V256.434Z",
    fill: "url(#paint50_linear_4156_16752)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M57 256.434H90.3754C94.5828 256.434 98 259.944 98 264.268V264.601C98 268.924 94.5841 272.434 90.3754 272.434H57V256.436V256.434Z",
    fill: "url(#paint51_linear_4156_16752)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M57 259.436H88.5231C91.5461 259.436 94 261.849 94 264.821V265.049C94 268.022 91.5461 270.434 88.5231 270.434H57V259.434V259.436Z",
    fill: "url(#paint52_linear_4156_16752)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.394 219.725C115.053 219.702 114.49 220.614 116.129 221.807C117.761 222.998 119.091 223.406 119.092 223.406C119.092 223.406 120.734 223.713 120.925 224.243C121.118 224.772 120.878 225.935 120.878 225.935C120.878 225.938 119.002 226.955 115.534 226.078C112.056 225.204 112.769 225.627 111.536 225.572C110.304 225.519 110 225.09 110 225.09C110 225.09 110.026 222.719 110.34 222.002C110.553 221.518 110.133 220.449 110.157 219.792C110.165 219.555 110.44 219.382 110.702 219.449C110.961 219.516 111.822 219.57 112.323 219.624C113.152 219.711 113.843 219.745 114.396 219.725H114.394Z",
    fill: "url(#paint53_linear_4156_16752)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5119 216.505C89.1003 216.824 88.1563 217.353 88.9999 219.27C89.8394 221.185 90.8029 222.242 90.8043 222.242C90.8043 222.242 92.0886 223.371 91.9951 223.947C91.9017 224.52 91.118 225.436 91.118 225.434C91.1167 225.437 88.9735 225.363 86.3687 222.787C83.7514 220.213 84.1655 220.959 83.1114 220.278C82.0558 219.599 82 219.06 82 219.059C82 219.059 83.1964 216.946 83.8253 216.463C84.252 216.137 84.6368 215.179 84.9826 214.601C85.1081 214.391 85.4344 214.377 85.631 214.572C85.8249 214.766 86.331 215.038 86.7438 215.344C87.428 215.849 88.0174 216.236 88.5119 216.503V216.505Z",
    fill: "url(#paint54_linear_4156_16752)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M110.001 221.434C110.233 217.872 111.069 207.886 111.149 203.396C111.286 197.99 114.159 192.507 114.349 192.112C114.243 191.214 112.764 183.295 112.123 177.536C111.508 171.292 110.588 157.674 110.55 157.677C113.589 157.595 116.629 157.516 119.669 157.434C119.697 157.413 122.628 171.295 121.877 181.131C121.691 183.772 121.55 186.417 121.201 189.046C121.072 190.988 116.87 213.078 115.002 220.52C113.491 220.935 111.54 221.234 110 221.434H110.001Z",
    fill: "url(#paint55_linear_4156_16752)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M84 217.13C84.9609 215.558 90.4965 206.312 92.9281 202.279C95.1956 198.601 98.8177 195.24 100.168 194.347C100.72 192.058 101.233 187.373 101.046 182.237C100.924 178.593 101.319 172.476 101.754 168.859C102.176 165.518 103.111 159.856 104.746 158.434C104.746 158.434 115.045 158.434 114.999 158.481C115.009 159.254 114.898 162.256 114.682 164.16C114.618 164.742 114.397 166.836 114.394 166.842C114.341 167.167 114.275 167.501 114.193 167.84C113.63 170.696 112.379 179.086 110.699 185.528C108.757 193.054 106.424 198.057 106.429 198.057C106.286 198.248 92.2651 215.433 88.6103 219.434C87.0753 218.662 85.5404 217.894 84.0027 217.13H84Z",
    fill: "url(#paint56_linear_4156_16752)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M109.308 133.028C111.423 129.705 119.783 133.424 126.929 132.594C126.939 132.594 126.95 132.592 126.961 132.59C131.008 129.177 135.862 124.301 138.362 121.447C139.176 120.526 139.746 119.822 139.964 119.46C140.967 117.794 142.407 118.313 141.892 119.908C141.759 120.32 141.251 121.383 140.425 122.847C139.785 123.98 139.116 125.09 138.409 126.175C137.526 127.53 136.601 128.85 135.639 130.134C134.566 131.564 133.447 132.95 132.271 134.274C131.42 135.233 130.537 136.155 129.622 137.041C129.423 137.234 129.238 137.372 128.959 137.428C128.621 137.498 128.285 137.581 127.947 137.651C127.236 137.797 126.519 137.924 125.796 138.029C114.97 139.649 107.343 136.091 109.31 133.029L109.308 133.028Z",
    fill: "url(#paint57_linear_4156_16752)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M125.859 138.025C116.792 139.415 109.493 137.064 109.023 134.032C108.948 133.546 109.055 133.069 109.34 132.615C110.637 130.524 114.089 131.013 118.086 131.58C120.856 131.973 123.993 132.418 126.893 132.08C130.643 128.83 135.031 124.342 137.585 121.434C137.621 121.483 137.669 121.527 137.732 121.566C138.562 122.079 139.298 122.707 140 123.381C139.498 124.263 138.998 125.095 138.482 125.906C137.618 127.264 136.694 128.619 135.732 129.932C134.63 131.439 133.505 132.856 132.39 134.145C131.545 135.121 130.661 136.07 129.759 136.964C129.537 137.184 129.322 137.347 128.998 137.413C128.83 137.448 128.662 137.488 128.494 137.527C128.328 137.566 128.162 137.604 127.995 137.639C127.273 137.792 126.552 137.922 125.855 138.025H125.859Z",
    fill: "#19779F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M139.652 118.224C140.083 117.558 140.367 116.664 140.8 116.806C141.011 116.876 140.763 117.66 140.589 118.382C140.944 117.876 141.315 117.454 141.603 117.22C142.462 116.522 142.352 115.857 142.478 115.599C142.602 115.341 142.69 114.347 143.05 114.441C143.404 114.536 144.33 117.472 143.878 118.735C143.405 119.993 140.627 122.427 140.637 122.434C140.239 122.17 139.84 121.907 139.441 121.646C138.551 121.195 139.211 118.889 139.652 118.225V118.224Z",
    fill: "url(#paint58_linear_4156_16752)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M107.483 131.434C107.73 131.687 108.274 132.254 110.379 132.424C111.775 132.536 113.315 132.502 113.64 132.2C123.971 136.327 120.405 158.434 120.405 158.434L105.113 158.368C105.113 158.368 94.4389 132.849 107.481 131.434H107.483Z",
    fill: "#078FCA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 120.434C112.432 120.434 113.721 120.62 113.953 121.679C114.186 122.738 113.55 123.73 112.091 123.353C110.632 122.976 110.531 120.831 112.432 120.434Z",
    fill: "#232323"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M113 131.172C112.98 131.161 112.959 131.15 112.939 131.14C112.676 131.454 111.439 131.49 110.318 131.373C108.653 131.201 108.203 130.624 108 130.354C108.177 129.871 108.431 129.062 108.601 128.016C108.884 126.266 108.394 124.434 108.394 124.434L111.401 124.977C111.401 124.977 111.363 126.475 111.75 128.306C112.106 129.994 112.881 131.022 113 131.171V131.172Z",
    fill: "url(#paint59_linear_4156_16752)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M108.078 119.512C104.968 120.202 104.245 123.726 105.772 125.456C107.18 127.051 108.099 126.141 108.888 127.437C109.498 128.438 111.71 129.598 112.809 129.415C113.909 129.233 114.434 126.697 113.564 123.402C112.694 120.108 109.791 119.132 108.078 119.512Z",
    fill: "url(#paint60_linear_4156_16752)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M113.159 131.434L114 131.902L113.498 132.434L112 131.919L113.159 131.434Z",
    fill: "#33A7D9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M107.937 130.434L107 131.467L111.092 133.434L112 132.254L107.937 130.434Z",
    fill: "#33A7D9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M107.395 119.735C104.55 120.907 104.655 124.15 105.59 125.463C106.525 126.776 108.049 127.434 108.049 127.434C108.049 127.434 107.823 126.109 108.642 125.435C109.462 124.76 109.083 122.785 110.292 122.198C111.501 121.611 112.687 122.638 113.709 121.551C114.731 120.465 112.917 117.862 110.496 118.548C108.075 119.233 108.091 119.449 107.395 119.735Z",
    fill: "#232323"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M109.198 124.622C109.198 124.622 107.605 123.75 108.093 125.767C108.58 127.784 110 127.406 110 127.406L109.198 124.622Z",
    fill: "url(#paint61_linear_4156_16752)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M108.663 132.4C110.729 135.899 102.743 141.582 99.7595 148.377C99.755 148.387 99.7505 148.398 99.746 148.407C100.877 153.678 102.983 160.377 104.396 163.992C104.849 165.165 105.222 166.016 105.454 166.387C106.52 168.089 105.262 169.127 104.005 167.896C103.68 167.577 102.931 166.61 101.965 165.163C101.218 164.042 100.507 162.908 99.8416 161.75C99.0103 160.305 98.2342 158.84 97.5134 157.358C96.7105 155.708 95.9748 154.036 95.3271 152.345C94.8584 151.121 94.4406 149.886 94.0764 148.639C93.9973 148.369 93.963 148.136 94.0555 147.859C94.169 147.522 94.266 147.182 94.3779 146.844C94.6137 146.137 94.8704 145.434 95.1524 144.737C99.3252 134.267 106.769 129.161 108.663 132.4Z",
    fill: "url(#paint62_linear_4156_16752)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.131 144.39C98.5566 135.851 104.492 130.569 107.513 131.552C107.996 131.708 108.378 132.02 108.647 132.478C109.89 134.568 107.652 137.352 105.061 140.574C103.265 142.808 101.231 145.337 100.039 148.021C101.072 152.78 102.908 158.663 104.248 162.222C104.184 162.231 104.119 162.253 104.051 162.29C103.151 162.778 102.195 163.132 101.214 163.434C100.667 162.593 100.164 161.775 99.6893 160.953C98.8923 159.577 98.1313 158.148 97.4268 156.709C96.6181 155.057 95.9021 153.426 95.3003 151.862C94.8446 150.678 94.4337 149.472 94.0822 148.276C93.9954 147.98 93.9592 147.719 94.0648 147.406C94.1198 147.243 94.1704 147.079 94.2225 146.915C94.2731 146.753 94.3238 146.591 94.3773 146.429C94.6117 145.729 94.8663 145.041 95.1325 144.388L95.131 144.39Z",
    fill: "#078FCA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M106.222 165.724C106.606 166.543 107.266 167.343 106.931 167.707C106.767 167.886 106.189 167.187 105.629 166.597C105.91 167.25 106.105 167.871 106.174 168.299C106.381 169.579 107.026 169.843 107.196 170.117C107.365 170.39 108.208 171.045 107.952 171.361C107.696 171.672 104.636 170.964 103.729 169.784C102.838 168.584 102.012 164.346 102 164.352C102.426 164.091 102.852 163.83 103.279 163.567C104.109 162.905 105.843 164.891 106.222 165.722V165.724Z",
    fill: "url(#paint63_linear_4156_16752)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M149 117.274L115.177 124.434L115 123.796L147.666 112.434L149 117.274Z",
    fill: "url(#paint64_linear_4156_16752)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M405.942 182.448C403.106 182.878 405.29 188.734 402.327 196.646C402.134 197.161 401.914 197.693 401.673 198.237C400.036 199.939 398.07 201.664 396.251 203.139L396.242 203.125C393.803 205.096 391.655 206.602 390.977 206.973C389.621 207.715 389.728 208.717 390.981 208.36C391.625 208.177 394.181 206.999 397.309 205.014L397.327 205.043C399.298 203.786 401.486 202.214 403.563 200.369C403.707 200.241 403.838 200.096 403.953 199.938C404.026 199.837 404.093 199.733 404.153 199.622C404.743 198.538 405.293 197.416 405.779 196.268C409.25 188.074 408.138 182.114 405.942 182.448Z",
    fill: "url(#paint65_linear_4156_16752)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M389.77 206.645C389.254 207.154 388.479 207.589 388.722 207.902C388.84 208.055 389.522 207.675 390.161 207.359C389.771 207.767 389.466 208.166 389.316 208.449C388.866 209.303 388.203 209.362 387.989 209.518C387.773 209.675 386.849 209.96 387.021 210.226C387.194 210.491 390.214 210.606 391.311 209.936C392.408 209.264 394 206.365 394 206.365L392.938 205.603C392.275 205.009 390.286 206.137 389.77 206.644V206.645Z",
    fill: "url(#paint66_linear_4156_16752)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M415.003 171.618C415.003 171.451 415.091 171.294 415.241 171.198C415.8 170.838 417.246 170.057 418.513 170.649C420.122 171.4 420.908 174.03 420.329 177.148C419.932 179.291 420.53 180.831 420.941 181.585C421.085 181.847 420.957 182.166 420.661 182.283C420.218 182.457 419.641 182.794 419.296 183.422C418.85 184.234 417.847 184.402 417.32 184.433C417.107 184.446 416.904 184.347 416.798 184.177C416.456 183.633 415.777 182.214 415.976 179.741C416.24 176.472 417.753 174.65 416.941 173.166C416.49 172.34 415.965 172.141 415.574 172.134C415.258 172.129 415 171.907 415 171.619L415.003 171.618Z",
    fill: "#FFCC51"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M412.976 180.692C414.975 181.131 416.86 182.879 416.951 185.155C416.983 185.448 417.001 185.762 417 186.1C416.997 187.451 416.716 189.186 416.059 191.452C414.119 198.142 413.149 202.434 413.149 202.434H404.164C404.164 202.434 404.21 201.5 404.168 201.105C404.125 200.709 404.06 200.145 403.993 199.471C403.836 197.131 403.893 196.181 403.581 193.833C403.528 193.439 403.477 193.044 403.427 192.647C403.418 191.741 403.3 190.766 403.198 189.774C403.164 189.444 403.132 189.111 403.106 188.779C402.804 187.125 403.166 185.588 403.952 184.29C404.148 183.965 404.372 183.654 404.618 183.361C406.499 181.455 409.21 180.126 411.926 180.496C412.613 180.54 412.978 180.69 412.978 180.69L412.976 180.692Z",
    fill: "url(#paint67_linear_4156_16752)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M404.47 184.434C404.47 184.434 402.522 187.619 402.07 189.048C401.63 190.44 403.401 192.434 403.401 192.434C403.401 192.434 404.72 191.964 404.95 189.065C405.194 185.995 404.468 184.434 404.468 184.434H404.47Z",
    fill: "url(#paint68_linear_4156_16752)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M403.71 192.856C403.758 193.205 403.804 193.551 403.853 193.896C404.07 195.46 404.114 196.382 404.17 197.547C404.25 199.222 404.357 200.812 404.261 202.434H416.609C415.77 200.902 414.927 199.34 415.213 197.643C415.552 195.628 416.529 193.697 417.091 191.705C417.679 189.616 418.078 187.434 417.987 185.245C417.887 182.826 415.793 181.123 413.771 180.694C413.703 180.67 413.32 180.538 412.658 180.497C412.34 180.456 412.013 180.434 411.687 180.434C409.345 180.434 406.892 181.511 404.958 183.387C404.697 183.687 404.459 184.003 404.255 184.327C403.727 185.164 403.571 186.123 403.271 187.044C402.992 187.894 402.407 188.56 402.092 189.382C401.544 190.816 403.624 192.775 403.712 192.857L403.71 192.856Z",
    fill: "url(#paint69_linear_4156_16752)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M412.006 174.434C412.006 174.434 411.652 176.075 411.861 177.785C412.069 179.486 412.992 180.656 412.992 180.656C413.15 180.733 410.949 182.015 409.964 182.248C407.847 182.751 406.93 182.138 407.004 181.561C407.004 181.561 407.775 179.891 408.026 178.025C408.34 175.689 407.758 174.632 407.758 174.632L412.005 174.436L412.006 174.434Z",
    fill: "url(#paint70_linear_4156_16752)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M409.419 168.435C414.344 168.392 414.704 172.718 413.255 174.53C411.927 176.192 411.513 175.32 410.797 176.642C410.246 177.661 407.95 178.524 406.825 178.427C405.7 178.33 404.543 176.375 405.183 173.085C405.829 169.764 407.613 168.451 409.418 168.435H409.419Z",
    fill: "url(#paint71_linear_4156_16752)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M406.419 170.991C407.172 171.358 408.085 171.358 408.921 171.213C409.064 171.207 409.2 171.213 409.327 171.225C410.073 171.305 410.651 171.743 410.869 172.301C411.199 173.142 411.255 173.989 411.419 174.847C411.433 174.919 411.456 174.988 411.486 175.051C411.534 175.152 411.603 175.239 411.697 175.306C411.853 175.384 412.013 175.424 412.17 175.434C413.171 175.373 413.788 174.608 414.32 174.059C414.389 173.963 414.452 173.865 414.507 173.764C414.562 173.664 414.609 173.561 414.649 173.455C414.693 173.361 414.734 173.262 414.772 173.16C414.962 172.648 415.064 172.044 414.956 171.445C414.926 171.288 414.884 171.131 414.822 170.975C414.769 170.862 414.711 170.751 414.646 170.643C414.073 169.401 412.49 168.715 410.856 168.515C410.652 168.49 410.447 168.472 410.241 168.463C409.306 168.364 408.484 168.533 407.658 168.793C407.348 168.925 407.02 169.057 406.747 169.227C406.656 169.284 406.57 169.346 406.492 169.414C406.18 169.738 405.71 170.368 406.24 170.836C406.326 170.916 406.417 170.99 406.417 170.99L406.419 170.991Z",
    fill: "#FFCC51"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M411.227 174.57C411.227 174.57 412.1 174.156 411.99 174.775C411.881 175.391 411 175.434 411 175.434L411.227 174.57Z",
    fill: "url(#paint72_linear_4156_16752)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M409.505 237.329C409.647 236.431 410.901 228.468 411.533 222.623C412.218 216.3 411.947 202.434 411.947 202.434H404.197C404.197 202.434 401.462 216.339 402.095 226.133C402.508 232.507 403.118 237.169 403.263 238.222C403.275 238.306 403.282 238.389 403.287 238.474C403.306 238.816 403.409 239.816 403.95 241.063C404.617 242.606 406.049 268.434 406.049 268.434H409.497C409.497 268.434 411.333 254.281 411.75 248.674C412.158 243.177 409.69 237.728 409.505 237.331V237.329Z",
    fill: "url(#paint73_linear_4156_16752)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M414.844 246.636C413.984 243.026 412.438 237.031 412.438 237.031C412.438 237.031 411.853 229.375 412.451 224.392C413.048 219.409 412.002 202.434 412.002 202.434L411.056 202.453C411.056 202.443 411.056 202.434 411.056 202.434H403.733C403.733 202.434 401.51 216.29 402.099 226.049C402.484 232.399 403.361 256.025 403.361 256.025C403.361 256.025 404.675 256.602 408.637 256.386C412.598 256.169 416 255.303 416 255.303C416 255.303 415.7 250.247 414.841 246.636H414.844Z",
    fill: "url(#paint74_linear_4156_16752)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M406.098 265.855C405.5 265.855 405.999 266.719 404.489 267.923C402.984 269.123 401.766 269.551 401.766 269.551C401.766 269.551 400.268 269.892 400.081 270.404C399.896 270.914 400.086 272.02 400.086 272.02C400.086 272.02 401.769 272.952 404.943 272.02C408.126 271.086 407.468 271.511 408.591 271.426C409.713 271.341 409.999 270.916 409.999 270.916C409.999 270.916 410.026 268.61 409.752 267.923C409.567 267.458 409.965 266.405 409.952 265.767C409.948 265.536 409.701 265.377 409.462 265.454C409.225 265.529 408.441 265.613 407.985 265.682C407.23 265.797 406.601 265.855 406.098 265.855Z",
    fill: "url(#paint75_linear_4156_16752)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M405.632 265.439C405.013 265.323 405.019 267.564 404.047 268.565C403.077 269.563 402 270.266 402 270.266C402 270.266 402.231 270.566 402.691 270.366C403.152 270.166 404.944 268.77 405.479 267.605C406.014 266.438 406.251 265.554 405.632 265.439Z",
    fill: "url(#paint76_linear_4156_16752)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M421.61 248.187C420.171 244.128 416.964 240.715 415.898 239.655C416.272 237.379 417.147 231.847 417.71 226.644C418.109 222.953 418.138 218.119 418.076 214.419C418.291 213.912 418.465 213.34 418.601 212.701C419.728 207.401 415.877 204.011 414.537 202.48L407.182 202.434C407.151 202.434 406.975 205.474 407.007 207.378C407.016 207.96 406.971 208.938 407.035 210.053C407.035 210.053 407.035 210.055 407.035 210.061C407.054 210.387 407.082 210.725 407.125 211.068C407.384 213.943 408.151 222.375 408.865 228.952C409.697 236.628 410.754 241.998 410.754 241.998C410.853 242.206 411.299 243.066 412.275 244.024C413.394 245.122 424.073 266.434 424.073 266.434L427 265.486C427 265.486 423.322 253.02 421.608 248.188L421.61 248.187Z",
    fill: "url(#paint77_linear_4156_16752)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M424.942 265.399C424.346 265.509 425.043 266.233 423.816 267.648C422.597 269.058 421.483 269.685 421.483 269.685C421.483 269.685 420.073 270.281 420.007 270.798C419.941 271.315 420.384 272.323 420.384 272.323C420.384 272.323 422.27 272.897 425.213 271.438C428.171 269.973 427.612 270.495 428.713 270.21C429.813 269.923 430 269.469 430 269.469C430 269.469 429.493 267.282 429.062 266.682C428.77 266.277 428.477 265.29 428.315 264.688C428.258 264.471 427.974 264.366 427.753 264.483C427.534 264.597 427.221 264.738 426.781 264.888C426.055 265.137 425.442 265.307 424.941 265.399H424.942Z",
    fill: "url(#paint78_linear_4156_16752)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M424.415 264.458C424.415 264.458 424.404 264.462 424.399 264.464C424.37 264.475 424.344 264.493 424.319 264.513C423.69 265.004 423.913 265.871 423.744 266.516C423.687 266.681 423.619 266.844 423.533 266.999C423.448 267.155 423.344 267.302 423.217 267.438C422.204 268.515 421 269.365 421 269.365C421 269.365 421.349 269.565 421.886 269.287C422.315 269.064 423.657 267.991 424.397 266.999C424.49 266.875 424.574 266.752 424.645 266.633C424.867 266.257 425.016 265.843 424.999 265.415C424.988 265.165 424.884 264.281 424.416 264.458H424.415Z",
    fill: "url(#paint79_linear_4156_16752)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M421.844 246.463C420.735 244.188 418.22 239.932 418.22 239.932C418.22 239.932 418.367 236.996 418.589 233.18C418.735 230.669 419.297 223.197 419.434 217.169C419.434 217.166 419.434 217.163 419.434 217.161V217.158C419.439 216.889 419.445 216.623 419.449 216.361C419.525 214.105 419.77 211.111 419.179 208.71C418.441 205.713 416.511 202.434 416.511 202.434H407.186C407.155 202.434 406.974 205.661 407.007 207.59C407.017 208.179 406.97 209.171 407.036 210.3C407.036 210.3 407.036 210.303 407.036 210.308C407.055 210.639 407.084 210.981 407.128 211.328C407.393 214.242 407.513 222.675 408.243 229.336C408.609 232.664 409.599 235.856 409.852 238.293C410.213 241.778 410.741 245.242 411.43 248.678C412.353 253.28 413.56 259.378 413.56 259.378C413.56 259.378 415.561 259.869 419.967 257.961C424.373 256.054 425 255.22 425 255.22C425 255.22 422.953 248.738 421.844 246.463Z",
    fill: "url(#paint80_linear_4156_16752)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M404.145 201.434L404 202.434H417L416.146 201.434H404.145Z",
    fill: "url(#paint81_linear_4156_16752)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M406.49 203.005C406.49 203.005 407.619 207.121 406.228 211.196C404.84 215.27 405.006 225.457 405.006 225.457L409.279 226.434C409.279 226.434 409.535 214.088 409.914 211.521C410.294 208.954 409.338 204.025 408.489 203.291C407.638 202.557 406.737 202.434 406.737 202.434L406.488 203.005H406.49Z",
    fill: "url(#paint82_linear_4156_16752)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M405.351 202.455L406 203.102C405.951 203.052 404.953 204.389 404.896 204.471C404.203 205.484 403.718 206.485 403.565 207.736C403.348 209.49 403.222 211.259 403.187 213.028C403.156 214.599 403.422 216.308 403.111 217.848C402.833 219.248 402.305 220.399 402.287 220.434C402.366 220.265 401.556 218.995 401.463 218.811C401.028 217.956 400.826 217.795 401.185 216.851C402.175 214.251 402.384 211.409 402.476 208.623C402.517 207.368 402.813 206.256 403.341 205.127C403.459 204.873 405.069 202.174 405.351 202.455Z",
    fill: "url(#paint83_linear_4156_16752)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M405.489 203.408C405.508 203.41 405.527 203.411 405.544 203.413C405.925 203.438 406.329 203.466 406.697 203.337C407.081 203.202 407.028 202.87 406.927 202.53C406.886 202.39 406.836 202.265 406.824 202.118C406.793 201.738 406.816 201.52 406.38 201.48C406.191 201.462 406.002 201.446 405.812 201.437C405.696 201.431 405.575 201.431 405.469 201.48C405.411 201.508 405.359 201.55 405.312 201.596C404.948 201.961 404.909 202.748 405.16 203.19C405.197 203.256 405.243 203.318 405.306 203.355C405.362 203.388 405.426 203.4 405.491 203.406L405.489 203.408Z",
    fill: "url(#paint84_linear_4156_16752)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M415.204 182.605C412.812 184.09 416.864 188.358 417.028 196.437C417.038 196.963 417.03 197.515 417.008 198.084C416.147 200.214 414.996 202.492 413.891 204.491L413.878 204.482C412.392 207.159 411.001 209.317 410.525 209.905C409.571 211.085 410.025 211.919 411.023 211.117C411.535 210.705 413.409 208.676 415.508 205.718L415.534 205.735C416.855 203.867 418.258 201.635 419.465 199.21C419.549 199.042 419.614 198.864 419.661 198.681C419.691 198.564 419.713 198.446 419.729 198.326C419.872 197.148 419.964 195.951 419.992 194.757C420.183 186.232 417.057 181.454 415.205 182.604L415.204 182.605Z",
    fill: "url(#paint85_linear_4156_16752)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M408.935 210.441C408.716 211.048 408.279 211.683 408.562 211.864C408.7 211.952 409.084 211.396 409.459 210.907C409.301 211.386 409.202 211.828 409.182 212.121C409.123 212.997 408.648 213.276 408.539 213.483C408.429 213.691 407.832 214.251 408.046 214.416C408.261 214.581 410.551 213.632 411.151 212.687C411.752 211.74 412 208.741 412 208.741L410.962 208.465C410.274 208.192 409.156 209.832 408.937 210.439L408.935 210.441Z",
    fill: "url(#paint86_linear_4156_16752)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M352.62 211.817C352.507 211.459 352.369 210.678 352.227 209.609C351.718 205.782 351.16 198.278 351.544 193.461C352.036 187.303 356.759 181.238 354.29 178.908C352.029 176.776 347.493 182.002 347.037 191.382C346.698 198.339 348.778 206.004 350.18 210.027C350.668 211.429 351.074 212.389 351.267 212.722C352.011 214.011 353.137 213.456 352.619 211.816L352.62 211.817Z",
    fill: "url(#paint87_linear_4156_16752)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M352.136 179.012C352.948 178.47 353.744 178.306 354.438 178.535C354.704 178.622 354.951 178.769 355.175 178.968C356.807 180.426 355.722 183.175 354.466 186.359C353.55 188.68 352.512 191.311 352.29 193.939C351.914 198.402 352.393 205.317 352.902 209.414C352.925 209.591 352.81 209.758 352.632 209.802C351.963 209.965 351.301 210.181 350.644 210.414C350.462 210.479 350.262 210.384 350.199 210.206C349.119 207.135 346.659 199.215 347.04 191.798C347.385 185.08 349.848 180.536 352.136 179.01V179.012Z",
    fill: "url(#paint88_linear_4156_16752)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M352.874 209.434L353 210.656L351.339 211.434L351 210.202L352.874 209.434Z",
    fill: "url(#paint89_linear_4156_16752)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M352.45 210.526C352.931 210.065 355.022 211.484 355.364 211.611C355.668 211.724 355.99 211.745 356.26 211.955C356.313 211.997 356.367 212.05 356.377 212.121C356.379 212.134 356.38 212.146 356.377 212.16C356.372 212.229 356.325 212.293 356.267 212.326C356.2 212.364 356.121 212.367 356.046 212.37C355.569 212.383 355.075 212.358 354.595 212.271C354.841 212.597 355.052 212.929 355.183 213.231C355.438 213.704 357.438 216.784 356.912 217.085C356.64 217.241 356.032 216.313 355.466 215.415C355.769 216.225 356.084 216.958 356.237 217.319C356.413 217.74 356.614 218.028 356.377 218.176C356.133 218.33 355.811 218.139 355.811 218.139C355.811 218.139 355.682 218.544 355.323 218.406C354.921 218.25 353.287 216.512 352.462 215.032C352.418 214.955 352.383 214.883 352.353 214.813C351.703 213.827 351 211.414 351 211.414C351 211.414 351.871 210.728 352.449 210.525L352.45 210.526Z",
    fill: "url(#paint90_linear_4156_16752)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M345.38 266.766C345.38 266.766 345.058 267.43 345.012 268.351C344.99 268.798 345.002 269.23 345.021 269.559C345.041 269.889 345.379 270.195 345.805 270.27C348.026 270.665 353.588 271.595 356.37 271.411C357.039 271.366 357.629 270.139 355.617 269.516C353.605 268.891 349.63 266.434 349.63 266.434L345.379 266.767L345.38 266.766Z",
    fill: "url(#paint91_linear_4156_16752)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M345.055 251.718C345.567 248.987 346.75 243.753 348.742 240.28C349.439 239.064 349.884 237.73 350.023 236.34C350.054 236.033 350.097 235.707 350.154 235.361C350.721 231.856 350.547 225.628 350.39 223.553C350.386 223.499 350.39 223.4 350.4 223.261C350.315 220.241 350.319 215.796 351.062 209.551C351.711 204.105 353.918 200.434 353.918 200.434C353.918 200.434 354.136 200.488 354.156 200.434H362.806C362.841 200.434 362.953 205.064 362.996 206.754C363.023 207.826 362.919 216.062 362.696 218.71C361.874 228.488 357.726 236.469 356.985 238.036C356.975 238.055 356.967 238.074 356.958 238.092C356.762 238.493 356.588 238.905 356.475 239.335C356.373 239.719 356.195 240.154 355.93 240.646C354.586 243.156 351.918 253.534 351.015 257.316C350.112 261.098 349.237 265.837 349.237 265.837L344 266.434C344 266.434 344.112 256.746 345.056 251.717L345.055 251.718Z",
    fill: "#078FCA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M356.482 175.861C357.016 175.076 357.235 173.471 357.232 173.113C357.226 172.234 357.18 170.459 357.028 170.48C357.028 170.48 359.639 170.102 360.945 171.526C361.027 171.615 361.103 171.703 361.179 171.789C361.254 171.876 361.323 171.962 361.39 172.046C361.894 172.661 363 174.298 363 174.298C363 174.298 362.17 174.278 362.065 175.463C361.982 176.388 362.601 178.33 362.601 178.33C362.601 178.33 362.405 179.044 361.495 179.263C361.211 179.372 360.831 179.435 360.348 179.419C360.336 179.419 360.323 179.421 360.309 179.422C358.088 179.567 355.974 178.382 355.658 178.194C355.34 178.005 355 177.759 355 177.759C355 177.759 355.948 176.646 356.483 175.859L356.482 175.861Z",
    fill: "url(#paint92_linear_4156_16752)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M358.92 171.98C359.882 172.135 360.009 173.953 362.791 174.354C364.219 174.558 364.352 174.441 364.765 173.205C365.165 172.008 365.368 166.548 362.685 165.27C360.002 163.991 356.998 164.141 355.708 165.992C354.417 167.844 354.569 171.276 358.92 171.98Z",
    fill: "url(#paint93_linear_4156_16752)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M355.496 166.622C355.496 166.622 355.498 166.615 355.501 166.611C355.547 166.468 355.601 166.329 355.66 166.195C355.841 165.532 355.618 165.14 356.492 164.371C357.537 163.45 358.012 163.438 358.677 163.508C359.342 163.578 359.2 162.536 360.293 162.441C361.385 162.346 361.433 163.391 362.05 163.508C362.668 163.625 363.713 162.156 365.265 163.508C366.817 164.861 365.566 166.621 364.663 166.716C363.761 166.811 363.662 166.477 363.038 166.995C362.52 167.671 363.292 168.596 363.137 169.014C362.857 169.768 362.119 169.33 361.608 170.563C360.659 172.859 357.763 172.396 357.763 172.396C357.763 172.396 356.972 171.644 356.29 170.558C355.737 169.823 355.217 169.059 355.113 168.665C354.875 167.762 355.018 167.572 355.494 166.622H355.496Z",
    fill: "url(#paint94_linear_4156_16752)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M362.999 170.246C363.023 169.917 362.675 169.604 362.101 169.48C361.624 169.376 361.121 169.415 361.015 169.98C360.804 171.112 362.915 171.434 362.915 171.434L362.999 170.246Z",
    fill: "url(#paint95_linear_4156_16752)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M360.381 266.833C360.381 266.833 360.059 267.629 360.012 268.734C359.989 269.269 360.003 269.79 360.021 270.183C360.04 270.579 360.378 270.946 360.805 271.037C363.026 271.51 368.587 272.627 371.369 272.406C372.039 272.353 372.63 270.881 370.618 270.132C368.607 269.384 364.499 266.434 364.499 266.434L360.381 266.833Z",
    fill: "url(#paint96_linear_4156_16752)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M358.684 200.436H365.478C365.51 200.436 367.53 216.301 367.795 219.22C368.708 229.271 366.303 237.474 365.896 239.086C365.893 239.096 365.892 239.104 365.889 239.114C365.769 239.577 365.691 240.053 365.645 240.532C365.611 240.9 365.524 241.31 365.383 241.769C364.592 244.349 363.934 255.016 363.758 258.904C363.581 262.791 364.076 267.662 364.076 267.662L357.851 268.434C357.851 268.434 357.169 258.317 357.054 253.148C356.989 250.168 357.268 244.634 358.591 241.065C358.978 240.025 359.128 238.895 359.008 237.765C358.961 237.329 358.932 236.852 358.921 236.334C358.84 232.731 357.963 226.33 357.469 224.197C357.254 223.271 356.562 220.357 356.311 217.271C356.166 215.491 355.815 213.728 355.333 211.997C355.313 211.923 355.292 211.848 355.273 211.772C354.024 206.878 357.397 201.81 358.684 200.434V200.436Z",
    fill: "#078FCA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M355.244 177.734C352.711 178.215 350.282 180.061 350.095 182.438C350.045 182.744 350.014 183.073 350.003 183.426C349.964 184.836 350.263 186.645 351.019 189.003C353.251 195.965 353.967 200.434 353.967 200.434L365.656 200.332C365.656 200.332 365.628 199.357 365.693 198.944C366.12 196.255 366.386 193.483 366.753 190.762C367.159 187.755 367.21 184.397 365.762 181.656C363.985 178.296 360.1 177.089 356.575 177.518C355.708 177.571 355.244 177.733 355.244 177.733V177.734Z",
    fill: "url(#paint97_linear_4156_16752)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M362.771 179.463C365.645 178.884 366.898 187.166 372.985 190.42C372.993 190.424 373.003 190.429 373.011 190.434C378.124 189.971 384.03 187.147 386.605 184.973C387.475 184.298 388.055 183.742 388.29 183.441C389.336 182.062 390.443 182.754 389.819 184.202C389.647 184.574 389.072 185.517 388.034 186.743C387.23 187.69 386.344 188.587 385.372 189.415C384.16 190.448 382.831 191.383 381.407 192.202C379.823 193.113 378.12 193.879 376.334 194.457C375.043 194.877 373.71 195.195 372.353 195.404C372.059 195.449 371.81 195.456 371.539 195.345C371.21 195.211 370.878 195.086 370.555 194.943C369.877 194.646 369.222 194.314 368.596 193.948C363.806 191.095 361.799 187.368 361.193 184.508C360.607 181.619 361.421 179.596 362.768 179.463H362.771Z",
    fill: "url(#paint98_linear_4156_16752)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M385.848 185.434L385 186.175L387.251 188.434L388 187.355L385.848 185.434Z",
    fill: "url(#paint99_linear_4156_16752)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M389.778 182.583C390.479 182.525 392.004 182.25 391.991 182.638C391.985 182.828 391.193 183.084 390.515 183.194C390.679 183.227 391.159 183.5 391.842 183.529C393.376 183.593 396.081 183.602 395.998 184.072C395.944 184.381 392.621 185.343 391.385 185.428C390.149 185.513 387 184.673 387 184.673L387.328 183.448C387.509 182.597 388.8 182.663 389.78 182.583H389.778Z",
    fill: "url(#paint100_linear_4156_16752)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M371.273 195.33C371.132 195.271 370.99 195.214 370.849 195.157C370.674 195.087 370.494 195.013 370.318 194.935C369.65 194.64 369.005 194.307 368.403 193.952C361.084 189.469 360.274 183.014 361.43 180.624C361.768 179.924 362.28 179.516 362.887 179.46C364.498 179.178 365.494 181.264 367.059 183.861C368.428 186.14 370.168 188.7 372.86 190.146C377.094 189.726 381.924 187.673 384.718 185.701C384.849 185.611 385.021 185.618 385.139 185.718C385.522 186.045 386.387 186.761 386.938 187.245C387.017 187.315 387.021 187.438 386.946 187.521C386.3 188.234 385.615 188.902 384.908 189.511C383.733 190.52 382.429 191.446 381.041 192.25C379.46 193.167 377.783 193.916 376.091 194.47C374.831 194.882 373.518 195.196 372.2 195.401C371.917 195.445 371.608 195.466 371.276 195.329L371.273 195.33Z",
    fill: "url(#paint101_linear_4156_16752)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M362.725 176.74L363 178.434L355 177.237L355.935 175.434L362.725 176.74Z",
    fill: "url(#paint102_linear_4156_16752)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M354 201.434H366V199.434H354V201.434Z",
    fill: "url(#paint103_linear_4156_16752)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M370.638 143.434H387.362C388.813 143.434 390 144.618 390 146.063V154.695C390 156.141 388.813 157.324 387.362 157.324H376.514L374.172 160.434V157.324H370.638C369.187 157.324 368 156.141 368 154.695V146.063C368 144.618 369.187 143.434 370.638 143.434Z",
    fill: "#FFCC51"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M383 151.434C383.552 151.434 384 150.987 384 150.434C384 149.882 383.552 149.434 383 149.434C382.448 149.434 382 149.882 382 150.434C382 150.987 382.448 151.434 383 151.434Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M379 151.434C380.105 151.434 381 150.987 381 150.434C381 149.882 380.105 149.434 379 149.434C377.895 149.434 377 149.882 377 150.434C377 150.987 377.895 151.434 379 151.434Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M375 151.434C375.552 151.434 376 150.987 376 150.434C376 149.882 375.552 149.434 375 149.434C374.448 149.434 374 149.882 374 150.434C374 150.987 374.448 151.434 375 151.434Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M398.242 154.434H380.758C379.241 154.434 378 155.618 378 157.063V165.695C378 167.141 379.241 168.324 380.758 168.324H392.099L394.547 171.434V168.324H398.242C399.759 168.324 401 167.141 401 165.695V157.063C401 155.618 399.759 154.434 398.242 154.434Z",
    fill: "#078FCA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M385.5 162.434C386.328 162.434 387 161.987 387 161.434C387 160.882 386.328 160.434 385.5 160.434C384.672 160.434 384 160.882 384 161.434C384 161.987 384.672 162.434 385.5 162.434Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M389.5 162.434C390.328 162.434 391 161.987 391 161.434C391 160.882 390.328 160.434 389.5 160.434C388.672 160.434 388 160.882 388 161.434C388 161.987 388.672 162.434 389.5 162.434Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M393 162.434C393.552 162.434 394 161.987 394 161.434C394 160.882 393.552 160.434 393 160.434C392.448 160.434 392 160.882 392 161.434C392 161.987 392.448 162.434 393 162.434Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M209.99 62.9807C209.99 52.9574 201.871 44.8299 191.846 44.8095C181.784 44.7878 173.663 52.8529 173.624 62.9087C173.607 67.2394 175.106 71.2196 177.623 74.3498C181.352 78.9887 183.443 84.7262 183.443 90.6769V90.7163H200.173V90.6769C200.173 84.7547 202.212 79.0131 205.943 74.4123C208.475 71.2902 209.991 67.3127 209.991 62.9807H209.99Z",
    fill: "#FFCC51"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M198.878 95.605H184.7C183.763 95.605 182.998 94.8404 182.998 93.9048C182.998 92.9691 183.763 92.2046 184.7 92.2046H198.878C199.814 92.2046 200.58 92.9691 200.58 93.9048C200.58 94.8404 199.814 95.605 198.878 95.605Z",
    fill: "#078FCA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M198.878 100.494H184.7C183.763 100.494 182.998 99.7292 182.998 98.7936C182.998 97.8579 183.763 97.0934 184.7 97.0934H198.878C199.814 97.0934 200.58 97.8579 200.58 98.7936C200.58 99.7292 199.814 100.494 198.878 100.494Z",
    fill: "#078FCA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M197.413 101.981H186.165C185.317 101.981 184.629 102.668 184.629 103.515V103.847C184.629 104.694 185.317 105.381 186.165 105.381H197.413C198.262 105.381 198.949 104.694 198.949 103.847V103.515C198.949 102.668 198.262 101.981 197.413 101.981Z",
    fill: "#078FCA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M189.77 90.7163L189.061 90.7122C189.061 90.6185 189.104 81.7156 188.55 76.6571C186.971 76.0256 185.362 75.3452 183.947 74.2738C182.889 73.4726 181.832 72.1078 181.857 70.8639C181.871 70.1618 182.224 69.5507 182.877 69.0958C183.363 68.7576 184.029 68.6327 184.702 68.7536C186.176 69.0197 187.309 69.9676 188.069 71.5714C188.72 72.9416 188.994 74.5603 189.163 75.8165C189.178 75.9265 189.191 76.0392 189.206 76.1546C189.447 76.2497 189.687 76.3461 189.926 76.4438L190.206 76.5579C191.688 77.1582 193.211 77.7747 194.797 78.0857C195.115 76.9938 195.642 76.0066 196.558 75.3289C197.23 74.8319 198.191 74.7722 198.896 75.185C199.488 75.5313 199.774 76.1369 199.683 76.8458C199.581 77.6416 198.959 78.3776 198.099 78.7226C197.289 79.0471 196.425 79.0118 195.761 78.9453C195.613 78.9303 195.465 78.9127 195.318 78.8923C195.112 79.8605 195.039 80.9089 194.971 81.8989C194.933 82.4489 194.896 82.969 194.839 83.4511C194.583 85.5953 194.454 87.9541 194.446 90.6647L193.737 90.662C193.746 87.9243 193.877 85.5383 194.135 83.3669C194.191 82.9024 194.226 82.3905 194.264 81.85C194.332 80.8763 194.407 79.7994 194.624 78.7742C192.988 78.451 191.443 77.8236 189.939 77.2152L189.659 77.1025C189.536 77.0536 189.414 77.0033 189.292 76.9544C189.81 82.1107 189.767 90.6253 189.767 90.7176L189.77 90.7163ZM195.498 78.1997C195.611 78.2147 195.722 78.2282 195.835 78.2391C196.699 78.326 197.317 78.2717 197.838 78.0626C198.463 77.8127 198.913 77.298 198.982 76.7535C199.051 76.2143 198.78 75.9346 198.54 75.7934C198.081 75.5245 197.425 75.5666 196.982 75.8952C196.23 76.452 195.779 77.2668 195.498 78.1984V78.1997ZM184.196 69.4163C183.848 69.4163 183.528 69.5059 183.283 69.677C182.81 70.0056 182.576 70.3981 182.567 70.8775C182.548 71.8661 183.491 73.038 184.377 73.7089C185.622 74.6513 186.998 75.2638 188.453 75.8531C188.084 73.1195 187.304 69.9432 184.577 69.4502C184.447 69.4271 184.32 69.4149 184.196 69.4149V69.4163Z",
    fill: "url(#paint104_linear_4156_16752)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M247.027 26.4317C247.027 18.3 240.44 11.707 232.307 11.6894C224.143 11.6717 217.555 18.2145 217.524 26.3733C217.51 29.8864 218.726 33.1157 220.767 35.6551C223.792 39.4181 225.488 44.0733 225.488 48.9009V48.9322H239.06V48.8996C239.06 44.095 240.714 39.4371 243.742 35.704C245.795 33.1714 247.026 29.9448 247.026 26.4303L247.027 26.4317Z",
    fill: "#FFCC51"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M238.013 52.8988H226.51C225.75 52.8988 225.129 52.2782 225.129 51.5191C225.129 50.76 225.75 50.1394 226.51 50.1394H238.013C238.772 50.1394 239.393 50.76 239.393 51.5191C239.393 52.2782 238.772 52.8988 238.013 52.8988Z",
    fill: "#078FCA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M238.013 56.8642H226.51C225.75 56.8642 225.129 56.2436 225.129 55.4845C225.129 54.7253 225.75 54.1047 226.51 54.1047H238.013C238.772 54.1047 239.393 54.7253 239.393 55.4845C239.393 56.2436 238.772 56.8642 238.013 56.8642Z",
    fill: "#078FCA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M236.824 58.0714H227.699C227.011 58.0714 226.453 58.6289 226.453 59.3167V59.5856C226.453 60.2733 227.011 60.8308 227.699 60.8308H236.824C237.512 60.8308 238.07 60.2733 238.07 59.5856V59.3167C238.07 58.6289 237.512 58.0714 236.824 58.0714Z",
    fill: "#078FCA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M230.623 48.9322L230.049 48.9294C230.049 48.8534 230.084 41.6316 229.634 37.5264C228.354 37.0144 227.048 36.4631 225.9 35.5926C225.041 34.9422 224.184 33.8354 224.204 32.8264C224.215 32.2574 224.502 31.7618 225.032 31.3924C225.426 31.1181 225.966 31.0162 226.513 31.1154C227.709 31.3313 228.629 32.0999 229.245 33.4009C229.773 34.513 229.997 35.8249 230.133 36.8447C230.145 36.9343 230.156 37.0253 230.168 37.119C230.362 37.1964 230.558 37.2738 230.752 37.3526L230.979 37.4449C232.181 37.9325 233.416 38.4322 234.704 38.6834C234.962 37.798 235.39 36.9968 236.134 36.4468C236.679 36.0435 237.46 35.9946 238.032 36.33C238.512 36.6111 238.744 37.1014 238.669 37.6772C238.586 38.3222 238.082 38.9197 237.384 39.1995C236.726 39.4629 236.025 39.4344 235.488 39.3801C235.367 39.3678 235.248 39.3529 235.129 39.3366C234.962 40.1229 234.902 40.973 234.847 41.7756C234.816 42.2223 234.787 42.6433 234.739 43.0344C234.533 44.774 234.428 46.6888 234.42 48.8873H233.845C233.853 46.6643 233.958 44.7278 234.169 42.9665C234.214 42.589 234.242 42.1748 234.273 41.7362C234.328 40.9458 234.389 40.0726 234.565 39.2415C233.238 38.9795 231.984 38.4716 230.765 37.9759L230.538 37.8836C230.439 37.8428 230.339 37.8034 230.24 37.7641C230.66 41.9467 230.626 48.8547 230.626 48.9294L230.623 48.9322ZM235.271 38.7785C235.362 38.7907 235.453 38.8016 235.544 38.8097C236.245 38.8803 236.746 38.8355 237.169 38.6671C237.676 38.4634 238.041 38.0479 238.097 37.6052C238.153 37.1679 237.933 36.9411 237.738 36.8271C237.365 36.6084 236.833 36.6437 236.473 36.9099C235.863 37.3621 235.498 38.0234 235.269 38.7785H235.271ZM226.101 31.6531C225.818 31.6531 225.559 31.7265 225.36 31.865C224.977 32.1325 224.787 32.4503 224.78 32.8386C224.764 33.6412 225.53 34.5918 226.249 35.135C227.259 35.8995 228.376 36.3966 229.557 36.8746C229.256 34.657 228.623 32.0795 226.411 31.6803C226.306 31.6613 226.203 31.6518 226.102 31.6518L226.101 31.6531Z",
    fill: "url(#paint105_linear_4156_16752)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M209.873 15.7998C209.873 10.9463 205.941 7.00953 201.087 7.00002C196.214 6.98916 192.281 10.8947 192.262 15.7658C192.254 17.8639 192.981 19.7909 194.199 21.3064C196.005 23.5525 197.017 26.3323 197.017 29.2126V29.2316H205.119V29.2126C205.119 26.3446 206.107 23.5648 207.912 21.3363C209.138 19.8249 209.873 17.8979 209.873 15.7998Z",
    fill: "#FFCC51"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M204.491 31.6H197.625C197.171 31.6 196.801 31.2293 196.801 30.777C196.801 30.3248 197.172 29.9541 197.625 29.9541H204.491C204.944 29.9541 205.314 30.3248 205.314 30.777C205.314 31.2293 204.944 31.6 204.491 31.6Z",
    fill: "#078FCA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M204.491 33.9668H197.625C197.171 33.9668 196.801 33.5961 196.801 33.1439C196.801 32.6917 197.172 32.3209 197.625 32.3209H204.491C204.944 32.3209 205.314 32.6917 205.314 33.1439C205.314 33.5961 204.944 33.9668 204.491 33.9668Z",
    fill: "#078FCA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M203.781 34.688H198.334C197.923 34.688 197.59 35.0206 197.59 35.4308V35.5924C197.59 36.0027 197.923 36.3352 198.334 36.3352H203.781C204.192 36.3352 204.525 36.0027 204.525 35.5924V35.4308C204.525 35.0206 204.192 34.688 203.781 34.688Z",
    fill: "#078FCA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M200.08 29.2329H199.736C199.736 29.1854 199.758 24.8738 199.489 22.424C198.724 22.1184 197.945 21.7884 197.26 21.2697C196.748 20.8813 196.236 20.22 196.248 19.6184C196.255 19.2789 196.426 18.9828 196.741 18.7628C196.976 18.5985 197.3 18.5388 197.626 18.5972C198.339 18.7262 198.888 19.1852 199.257 19.9619C199.572 20.626 199.705 21.4096 199.787 22.0179C199.793 22.0709 199.8 22.1266 199.807 22.1823C199.924 22.2284 200.039 22.2746 200.156 22.3221L200.292 22.3765C201.01 22.6671 201.747 22.9658 202.515 23.1166C202.669 22.5883 202.924 22.1103 203.369 21.7817C203.695 21.5413 204.159 21.5114 204.502 21.7124C204.787 21.8794 204.927 22.1728 204.882 22.5163C204.833 22.902 204.532 23.2578 204.115 23.4248C203.722 23.5823 203.303 23.5647 202.983 23.5335C202.911 23.5267 202.84 23.5172 202.768 23.5077C202.667 23.9762 202.632 24.484 202.599 24.9634C202.58 25.2296 202.563 25.4808 202.536 25.7144C202.412 26.7532 202.349 27.8953 202.345 29.2085H202.001C202.006 27.8817 202.069 26.7261 202.194 25.675C202.222 25.4496 202.238 25.2024 202.257 24.9403C202.29 24.4691 202.326 23.9476 202.431 23.4506C201.639 23.2945 200.89 22.9903 200.162 22.6956L200.026 22.6413C199.966 22.6168 199.907 22.5937 199.848 22.5693C200.098 25.0666 200.079 29.1895 200.077 29.2343L200.08 29.2329ZM202.854 23.1722C202.908 23.179 202.962 23.1858 203.017 23.1912C203.435 23.2333 203.734 23.2075 203.987 23.1057C204.29 22.9848 204.507 22.7363 204.541 22.4715C204.575 22.2108 204.443 22.075 204.328 22.0071C204.105 21.8767 203.788 21.8971 203.574 22.056C203.21 22.3262 202.992 22.72 202.855 23.1709L202.854 23.1722ZM197.38 18.919C197.211 18.919 197.057 18.9625 196.937 19.0453C196.709 19.2042 196.595 19.3943 196.59 19.6265C196.581 20.1059 197.038 20.6735 197.467 20.9981C198.069 21.4544 198.736 21.7518 199.441 22.037C199.262 20.7129 198.884 19.1743 197.563 18.9367C197.501 18.9258 197.44 18.9204 197.379 18.9204L197.38 18.919Z",
    fill: "url(#paint106_linear_4156_16752)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M449.496 61.1694C448.095 61.1134 446.745 61.2909 445.482 61.6621C445.488 61.5125 445.49 61.363 445.49 61.2122C445.49 53.9965 439.451 48.1479 432.002 48.1479C429.923 48.1479 427.952 48.6045 426.192 49.4188C423.373 45.1722 418.429 42.374 412.815 42.4354C404.463 42.5276 397.582 49.061 397.331 57.1484C397.302 58.0923 397.362 59.0174 397.504 59.9172C397.228 59.8999 396.95 59.8905 396.67 59.8905C389.481 59.8905 383.689 65.6911 384.013 72.7238C384.316 79.3067 390.048 84.4344 396.852 84.4344H448.986C455.673 84.4344 461.086 79.1412 460.999 72.6438C460.918 66.5041 455.829 61.4258 449.496 61.1708V61.1694Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M342.391 24.7067C341.388 24.6752 340.421 24.8108 339.514 25.0862C339.518 24.9725 339.521 24.8574 339.521 24.7423C339.521 19.245 335.05 14.7874 329.536 14.7874C327.995 14.7874 326.538 15.1353 325.235 15.7559C323.148 12.5188 319.487 10.3873 315.331 10.4352C309.039 10.5078 303.905 15.6545 303.866 21.9272C303.862 22.5492 303.907 23.1601 303.998 23.7547C303.793 23.741 303.588 23.7341 303.379 23.7341C298.092 23.7341 293.827 28.0958 294.005 33.4083C294.176 38.4631 298.42 42.4344 303.493 42.4344H342.107C347 42.4344 350.971 38.4946 351 33.6233C351.029 28.8411 347.185 24.8547 342.39 24.7067H342.391Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.5162 66.49C45.6252 66.4556 46.6947 66.6071 47.6964 66.917C47.6923 66.7889 47.6896 66.6608 47.6896 66.5314C47.6896 60.3456 52.6302 55.3319 58.7258 55.3319C60.4279 55.3319 62.0404 55.7231 63.4791 56.4214C65.7852 52.7796 69.8313 50.3816 74.4258 50.4353C81.3792 50.5166 87.0528 56.3071 87.0975 63.3634C87.1016 64.0631 87.0514 64.7504 86.951 65.4198C87.1763 65.4047 87.4043 65.3964 87.6337 65.3964C93.4782 65.3964 98.1921 70.304 97.994 76.279C97.8053 81.9662 93.1145 86.4344 87.5075 86.4344H44.8298C39.4209 86.4344 35.0328 82.002 35.0002 76.5215C34.9676 71.1401 39.2173 66.6567 44.5162 66.49Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.7476 146.475C70.9026 146.449 70.0881 146.563 69.3246 146.795C69.3274 146.698 69.3301 146.602 69.3301 146.505C69.3301 141.866 65.5652 138.106 60.9223 138.106C59.6259 138.106 58.3971 138.4 57.3009 138.924C55.5434 136.194 52.4606 134.395 48.9607 134.435C43.6634 134.496 39.3393 138.839 39.3062 144.132C39.3034 144.656 39.3407 145.172 39.418 145.674C39.2455 145.663 39.0729 145.656 38.8975 145.656C34.4451 145.656 30.8528 149.337 31.0046 153.817C31.1482 158.083 34.7226 161.434 38.9942 161.434H71.5101C75.6312 161.434 78.975 158.109 78.9999 154C79.0247 149.964 75.7872 146.602 71.7489 146.475H71.7476Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5216 271.434H448.478C448.766 271.434 449 271.608 449 271.823V272.046C449 272.26 448.766 272.434 448.478 272.434H31.5216C31.2338 272.434 31 272.26 31 272.046V271.823C31 271.608 31.2338 271.434 31.5216 271.434Z",
    fill: "#233862"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4156_16752",
    x1: 246.999,
    y1: -11.2498,
    x2: 246.999,
    y2: 330.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4156_16752",
    x1: 226.908,
    y1: 180.067,
    x2: 292.026,
    y2: 222.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4156_16752",
    x1: 249.684,
    y1: 180.877,
    x2: 261.601,
    y2: 199.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4156_16752",
    x1: 247.737,
    y1: 228.275,
    x2: 225.817,
    y2: 164.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4156_16752",
    x1: 254.851,
    y1: 234.547,
    x2: 226.575,
    y2: 166.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4156_16752",
    x1: 279.482,
    y1: 189.938,
    x2: 243.05,
    y2: 293.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4156_16752",
    x1: 167.891,
    y1: 179.912,
    x2: 249.559,
    y2: 252.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4156_16752",
    x1: 197.042,
    y1: 243.352,
    x2: 233.511,
    y2: 257.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4156_16752",
    x1: 243.988,
    y1: 203.592,
    x2: 292.689,
    y2: 224.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4156_16752",
    x1: 240.573,
    y1: 225.408,
    x2: 269.616,
    y2: 247.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4156_16752",
    x1: 270.629,
    y1: 188.197,
    x2: 290.271,
    y2: 259.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4156_16752",
    x1: 295.87,
    y1: 179.253,
    x2: 283.542,
    y2: 182.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4156_16752",
    x1: 276.054,
    y1: 174.623,
    x2: 289.255,
    y2: 196.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4156_16752",
    x1: 279.563,
    y1: 200.326,
    x2: 290.962,
    y2: 156.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4156_16752",
    x1: 232.57,
    y1: 211.824,
    x2: 273.555,
    y2: 214.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4156_16752",
    x1: 243.591,
    y1: 215.465,
    x2: 261.776,
    y2: 204.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#491CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4156_16752",
    x1: 266.881,
    y1: 205.557,
    x2: 248.028,
    y2: 230.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#491CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4156_16752",
    x1: 231.123,
    y1: 196.186,
    x2: 249.252,
    y2: 204.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4156_16752",
    x1: 255.482,
    y1: 144.908,
    x2: 152.824,
    y2: 313.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4156_16752",
    x1: 154,
    y1: 197.934,
    x2: 219.999,
    y2: 197.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4156_16752",
    x1: 214,
    y1: 135.934,
    x2: 242.999,
    y2: 135.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4156_16752",
    x1: 209,
    y1: 149.434,
    x2: 236,
    y2: 149.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4156_16752",
    x1: 202,
    y1: 163.434,
    x2: 231,
    y2: 163.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4156_16752",
    x1: 196,
    y1: 178.434,
    x2: 223.999,
    y2: 178.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4156_16752",
    x1: 190,
    y1: 191.434,
    x2: 219,
    y2: 191.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4156_16752",
    x1: 184,
    y1: 205.934,
    x2: 212,
    y2: 205.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4156_16752",
    x1: 178,
    y1: 219.434,
    x2: 205.999,
    y2: 219.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4156_16752",
    x1: 172,
    y1: 233.434,
    x2: 200,
    y2: 233.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4156_16752",
    x1: 165,
    y1: 247.933,
    x2: 193.999,
    y2: 247.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4156_16752",
    x1: 159.999,
    y1: 261.434,
    x2: 187.999,
    y2: 261.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4156_16752",
    x1: 182.001,
    y1: 197.934,
    x2: 247,
    y2: 197.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4156_16752",
    x1: 204.345,
    y1: 225.266,
    x2: 173.893,
    y2: 191.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4156_16752",
    x1: 179.253,
    y1: 225.876,
    x2: 217.775,
    y2: 172.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4156_16752",
    x1: 203.346,
    y1: 176.579,
    x2: 185.899,
    y2: 179.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4156_16752",
    x1: 196.259,
    y1: 172.801,
    x2: 186.792,
    y2: 174.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4156_16752",
    x1: 180.536,
    y1: 243.663,
    x2: 245.373,
    y2: 178.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4156_16752",
    x1: 168.614,
    y1: 105.127,
    x2: 204.773,
    y2: 339.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4156_16752",
    x1: 197.679,
    y1: 204.891,
    x2: 198.566,
    y2: 200.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DA1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C4AE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4156_16752",
    x1: 198.536,
    y1: 183.049,
    x2: 138.314,
    y2: 205.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4156_16752",
    x1: 230.484,
    y1: 174.818,
    x2: 164.964,
    y2: 204.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4156_16752",
    x1: 140.62,
    y1: 154.791,
    x2: 248.448,
    y2: 210.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4156_16752",
    x1: 199.632,
    y1: 183.657,
    x2: 139.967,
    y2: 204.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4156_16752",
    x1: 225.284,
    y1: 178.816,
    x2: 171.508,
    y2: 199.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4156_16752",
    x1: 86.2489,
    y1: 254.898,
    x2: 184.934,
    y2: 236.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4156_16752",
    x1: 79.085,
    y1: 263.326,
    x2: 103.803,
    y2: 232.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4156_16752",
    x1: 117.112,
    y1: 271.576,
    x2: 142.381,
    y2: 247.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4156_16752",
    x1: 82.1936,
    y1: 239.292,
    x2: 176.354,
    y2: 224.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4156_16752",
    x1: 56.2554,
    y1: 224.224,
    x2: 100.304,
    y2: 228.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3165CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4156_16752",
    x1: 96.7782,
    y1: 236.537,
    x2: 71.0244,
    y2: 234.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DEE8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D4E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4156_16752",
    x1: 84.8049,
    y1: 238.934,
    x2: 53.0556,
    y2: 238.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CAAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4156_16752",
    x1: 88.0787,
    y1: 267.52,
    x2: 171.457,
    y2: 252.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4156_16752",
    x1: 34.4589,
    y1: 255.466,
    x2: 104.282,
    y2: 270.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3165CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4156_16752",
    x1: 99.9832,
    y1: 262.786,
    x2: 59.2679,
    y2: 266.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F0F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DEE8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D4E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4156_16752",
    x1: 125.197,
    y1: 250.604,
    x2: 125.146,
    y2: 221.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4156_16752",
    x1: 89.4755,
    y1: 246.079,
    x2: 95.138,
    y2: 218.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4156_16752",
    x1: 124.025,
    y1: 294.41,
    x2: 122.104,
    y2: 150.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4156_16752",
    x1: 84.3521,
    y1: 246.421,
    x2: 129.885,
    y2: 129.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4156_16752",
    x1: 164.527,
    y1: 96.1913,
    x2: 92.1798,
    y2: 161.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4156_16752",
    x1: 184.054,
    y1: 159.062,
    x2: 123.731,
    y2: 299.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4156_16752",
    x1: 98.1487,
    y1: 143.467,
    x2: 126.938,
    y2: 120.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4156_16752",
    x1: 118.648,
    y1: 115.893,
    x2: 81.2784,
    y2: 154.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4156_16752",
    x1: 122.636,
    y1: 104.77,
    x2: 51.9473,
    y2: 152.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4156_16752",
    x1: 113.098,
    y1: 200.717,
    x2: 90.9202,
    y2: 103.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4156_16752",
    x1: 81.2023,
    y1: 195.752,
    x2: -32.7144,
    y2: 70.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4156_16752",
    x1: 73.926,
    y1: 79.3438,
    x2: 171.304,
    y2: 149.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4156_16752",
    x1: 427.811,
    y1: 233.292,
    x2: 384.319,
    y2: 175.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4156_16752",
    x1: 425.757,
    y1: 185.233,
    x2: 365.03,
    y2: 227.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4156_16752",
    x1: 381.383,
    y1: 216.637,
    x2: 358.249,
    y2: 154.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4156_16752",
    x1: 399.7,
    y1: 223.49,
    x2: 365.739,
    y2: 162.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4156_16752",
    x1: 406.798,
    y1: 178.341,
    x2: 421.002,
    y2: 226.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4156_16752",
    x1: 429.345,
    y1: 199.45,
    x2: 401.48,
    y2: 163.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4156_16752",
    x1: 408.91,
    y1: 173.434,
    x2: 421.376,
    y2: 173.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4156_16752",
    x1: 422.746,
    y1: 171.856,
    x2: 409.482,
    y2: 181.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4156_16752",
    x1: 403.133,
    y1: 315.662,
    x2: 414.679,
    y2: 189.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4156_16752",
    x1: 375.587,
    y1: 136.516,
    x2: 418.866,
    y2: 270.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4156_16752",
    x1: 407.561,
    y1: 273.949,
    x2: 415.92,
    y2: 266.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4156_16752",
    x1: 406.34,
    y1: 261.987,
    x2: 418.964,
    y2: 276.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4156_16752",
    x1: 405.483,
    y1: 193.688,
    x2: 445.796,
    y2: 332.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4156_16752",
    x1: 419.404,
    y1: 273.412,
    x2: 427.329,
    y2: 265.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4156_16752",
    x1: 416.61,
    y1: 259.173,
    x2: 426.153,
    y2: 275.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4156_16752",
    x1: 392.643,
    y1: 157.856,
    x2: 443.168,
    y2: 322.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4156_16752",
    x1: 410.501,
    y1: 196.157,
    x2: 410.501,
    y2: 206.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4156_16752",
    x1: 407.376,
    y1: 227.645,
    x2: 407.5,
    y2: 204.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4156_16752",
    x1: 400.648,
    y1: 223.956,
    x2: 405.903,
    y2: 201.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4156_16752",
    x1: 404.998,
    y1: 211.141,
    x2: 406.153,
    y2: 202.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B56C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4156_16752",
    x1: 453.522,
    y1: 218.234,
    x2: 394.737,
    y2: 182.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4156_16752",
    x1: 428.799,
    y1: 179.824,
    x2: 391.183,
    y2: 232.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4156_16752",
    x1: 354.774,
    y1: 229.052,
    x2: 346.928,
    y2: 141.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4156_16752",
    x1: 380.362,
    y1: 158.359,
    x2: 337.114,
    y2: 216.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4156_16752",
    x1: 353.674,
    y1: 212.409,
    x2: 348.9,
    y2: 208.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4156_16752",
    x1: 369.716,
    y1: 240.418,
    x2: 306.121,
    y2: 152.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4156_16752",
    x1: 363.083,
    y1: 266.226,
    x2: 351.526,
    y2: 275.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4156_16752",
    x1: 355.501,
    y1: 203.826,
    x2: 359.948,
    y2: 159.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4156_16752",
    x1: 365.293,
    y1: 168.823,
    x2: 354.998,
    y2: 170.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4156_16752",
    x1: 363.412,
    y1: 157.543,
    x2: 357.516,
    y2: 175.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4156_16752",
    x1: 359.971,
    y1: 169.776,
    x2: 365.481,
    y2: 175.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4156_16752",
    x1: 378.173,
    y1: 266.133,
    x2: 364.929,
    y2: 274.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4156_16752",
    x1: 422.539,
    y1: 213.947,
    x2: 442.983,
    y2: 145.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4156_16752",
    x1: 415.855,
    y1: 175.148,
    x2: 351.211,
    y2: 192.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4156_16752",
    x1: 387.371,
    y1: 187.713,
    x2: 384.363,
    y2: 192.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4156_16752",
    x1: 416.753,
    y1: 178.601,
    x2: 352.03,
    y2: 200.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4156_16752",
    x1: 408.446,
    y1: 191.702,
    x2: 322.776,
    y2: 182.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4156_16752",
    x1: 358.021,
    y1: 181.277,
    x2: 368.14,
    y2: 156.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4156_16752",
    x1: 360.974,
    y1: 204.931,
    x2: 357.148,
    y2: 192.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DA1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C4AE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4156_16752",
    x1: 227.184,
    y1: 97.4546,
    x2: 189.614,
    y2: 80.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4156_16752",
    x1: 260.977,
    y1: 54.398,
    x2: 230.495,
    y2: 40.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4156_16752",
    x1: 218.199,
    y1: 32.4948,
    x2: 200.005,
    y2: 24.4549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.b7b0c19593d2cac5e819ae328a2e8e6b.svg";
export { ForwardRef as ReactComponent };